import React, { createContext, useState, useEffect, useContext } from 'react';
import { getAllMasterData } from '../services/masterDataService';

const MasterDataContext = createContext(null);

export const MasterDataProvider = ({ children }) => {
  const [masterData, setMasterData] = useState({
    categories: [],
    checklists: [],
    roles: [],
    skills: [],
    certifications: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all master data on mount
  useEffect(() => {
    fetchMasterData();
  }, []);

  const fetchMasterData = async () => {
    setLoading(true);
    setError(null);

    const response = await getAllMasterData();

    if (response.success) {
      setMasterData(response.data);
    } else {
      setError(response.error);
      console.error('Failed to fetch master data:', response.error);
    }

    setLoading(false);
  };

  const value = {
    // Data
    categories: masterData.categories,
    checklists: masterData.checklists,
    roles: masterData.roles,
    skills: masterData.skills,
    certifications: masterData.certifications,

    // State
    loading,
    error,

    // Methods
    refetchMasterData: fetchMasterData,
  };

  return (
    <MasterDataContext.Provider value={value}>
      {children}
    </MasterDataContext.Provider>
  );
};

export const useMasterData = () => {
  const context = useContext(MasterDataContext);
  if (!context) {
    throw new Error('useMasterData must be used within MasterDataProvider');
  }
  return context;
};
